import { render, staticRenderFns } from "./Bestellung.vue?vue&type=template&id=0840d582&"
import script from "./Bestellung.vue?vue&type=script&lang=js&"
export * from "./Bestellung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports